import React, { Component } from "react"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { clearSearch, getRatings, hideAttemptsModal, hideCalendarModal, hideHistoryModal, hideLastRoundResults, hideStatModal, init, loadHistory, ratingsSearch, refreshHistoryModal, searchInputChange, selectRatingLeague, setIsParticipant, setPrepareStageTab, setSelectedTab, setUseAttempts, showAttemptsModal, showCalendarModal, showHistoryModal, showLastRoundResults, showNationShipTypeStatistic, showOwnClanPosition, showSeasonLeaders, showStatModal, toggleAutoParticipation, togglePlayersCountInRating } from "../Actions/ActionClanWars"
import ViewClanWars from "../Components/ViewClanWars/ViewClanWars"
import { ICommonInfo, IHistoryRound, ILastRoundResults, IStages, IWarSettings, Ship } from "../Reducers/ReducerClanWars"
import { ClanRec2IsEnabled } from 'helpers/common'

type State = any

export interface ContainerClanWars_Props {
  clanId: number | null
  isOnline: boolean
  selectedTab: number
  prepageStageTabIndex: number
  isAttemptHistoryModalVisible: boolean
  isStatModalVisible: boolean
  autoParticipation: boolean
  selectedStatisticNation: string | null
  selectedStatisticType: string | null
  selectedAttemptsUserId: string | null
  allPlayersInRatingTable: boolean
  currentAccount: {}
  settings: any
  clanInfo: {
    color: string
    createdAt: string
    id: number
    isPreloadedData: boolean
    maxMembersCount: number
    members_count: number
    name: string
    rawDescription: string
    status: string
    tag: string
  }

  commonInfo: ICommonInfo
  stages: IStages
  warSettings: IWarSettings
  groupedBattles: any

  selectedClanRatingLeague: string | null
  searchInputValue: string
  clanRatingList: {
    data: Array<any>
    meta: any
  }
  clanRatingSearchList: {
    data: Array<any>
    meta: any
  }
  clanRatingAutocomplete: {
    data: Array<any>
    meta: any
  }
  selectedClanId: number | null
  root: string
  isReady: boolean
  isCalendarModalVisible: boolean
  isHistoryModalVisible: boolean
  restriction: null | number
  nextWeekStartDate: string
  lastRoundResults: null | ILastRoundResults
  lastRoundResultsReady: boolean
  lastRoundResultsHidden: boolean
  useAttempts: boolean
  isFromPort: boolean
  router: any
  hasErrors: boolean
  ships: {
    [shipId: number]: Ship
  }
  roundsHistory: Array<IHistoryRound>
  roundsHistoryCount: number
  roundsHistoryOffset: number
  roundsHistoryLimit: number
  isRoundsHistoryLoading: boolean

  init: (isReload: boolean) => void
  setSelectedTab: (selectedTab: number) => void
  setPrepareStageTab: (prepageStageTabIndex: number) => void
  showStatModal: () => void
  hideStatModal: () => void
  showAttemptsModal: (id: string) => void
  hideAttemptsModal: () => void
  toggleAutoParticipation: () => void
  setIsParticipant: (value: boolean) => void
  showNationShipTypeStatistic: (nation: string, type: string) => void
  selectRatingLeague: (league: string) => void
  searchInputChange: (value: string) => void
  getRatings: (clanId?: number, league?: number) => void
  ratingsSearch: (query: string) => void
  clearSearch: () => void
  showOwnClanPosition: () => void
  showSeasonLeaders: () => void
  showCalendarModal: () => void
  hideCalendarModal: () => void
  togglePlayersCountInRating: () => void
  hideLastRoundResults: () => void
  showLastRoundResults: () => void
  setUseAttempts: (val: boolean) => void
  showHistoryModal: () => void
  loadHistory: () => void
  hideHistoryModal: () => void
  refreshHistoryModal: () => void
}

export interface ContainerClanWars_State { }
class ContainerClanWars extends Component<ContainerClanWars_Props, ContainerClanWars_State> {

  componentDidMount() {
    this.props.init(false)
  }

  componentWillUnmount() {
    this.props.hideStatModal()
    this.props.hideAttemptsModal()
  }

  navigateToClan = (clanId: number) => {
    if (clanId) {
      this.props.router.push(`${this.props.root}clan-profile/${clanId}`)
    }
  }

  navigateToRecommendations = () => {
    const url = ClanRec2IsEnabled ? 'new-recommendations' : 'recommendations'
    this.props.router.push(this.props.root + url)
  }


  setSelectedTab = (selectedTab: number) => {
    switch (selectedTab) {
      case 0:
        {
          this.props.router.push(`${this.props.root}clan-wars/war`)
          break
        }
      case 1:
        {
          this.props.router.push(`${this.props.root}clan-wars/rating`)
          break
        }
      case 2:
        {
          this.props.router.push(`${this.props.root}clan-wars/rules`)
          break
        }
      default:
        {
          break
        }
    }
  }

  render() {
    return (
      <ViewClanWars
        clanId={this.props.clanId}
        settings={this.props.settings}
        selectedTab={this.props.selectedTab}
        prepageStageTabIndex={this.props.prepageStageTabIndex}
        isAttemptHistoryModalVisible={this.props.isAttemptHistoryModalVisible}
        isStatModalVisible={this.props.isStatModalVisible}
        autoParticipation={this.props.autoParticipation}
        selectedStatisticNation={this.props.selectedStatisticNation}
        selectedStatisticType={this.props.selectedStatisticType}
        selectedAttemptsUserId={this.props.selectedAttemptsUserId}
        isOnline={this.props.isOnline}
        allPlayersInRatingTable={this.props.allPlayersInRatingTable}
        currentAccount={this.props.currentAccount}
        clanInfo={this.props.clanInfo}
        commonInfo={this.props.commonInfo}
        stages={this.props.stages}
        warSettings={this.props.warSettings}
        groupedBattles={this.props.groupedBattles}
        restriction={this.props.restriction}
        nextWeekStartDate={this.props.nextWeekStartDate}
        selectedClanRatingLeague={this.props.selectedClanRatingLeague}
        searchInputValue={this.props.searchInputValue}
        clanRatingList={this.props.clanRatingList}
        clanRatingSearchList={this.props.clanRatingSearchList}
        clanRatingAutocomplete={this.props.clanRatingAutocomplete}
        selectedClanId={this.props.selectedClanId}
        isReady={this.props.isReady}
        isCalendarModalVisible={this.props.isCalendarModalVisible}
        isHistoryModalVisible={this.props.isHistoryModalVisible}
        lastRoundResults={this.props.lastRoundResults}
        lastRoundResultsReady={this.props.lastRoundResultsReady}
        lastRoundResultsHidden={this.props.lastRoundResultsHidden}
        useAttempts={this.props.useAttempts}
        isFromPort={this.props.isFromPort}
        hasErrors={this.props.hasErrors}
        ships={this.props.ships}
        roundsHistory={this.props.roundsHistory}
        roundsHistoryCount={this.props.roundsHistoryCount}
        roundsHistoryOffset={this.props.roundsHistoryOffset}
        roundsHistoryLimit={this.props.roundsHistoryLimit}
        isRoundsHistoryLoading={this.props.isRoundsHistoryLoading}
        setSelectedTab={this.setSelectedTab}
        setPrepareStageTab={this.props.setPrepareStageTab}
        showStatModal={this.props.showStatModal}
        hideStatModal={this.props.hideStatModal}
        showAttemptsModal={this.props.showAttemptsModal}
        hideAttemptsModal={this.props.hideAttemptsModal}
        toggleAutoParticipation={this.props.toggleAutoParticipation}
        setIsParticipant={this.props.setIsParticipant}
        showNationShipTypeStatistic={this.props.showNationShipTypeStatistic}
        selectRatingLeague={this.props.selectRatingLeague}
        searchInputChange={this.props.searchInputChange}
        getRatings={this.props.getRatings}
        ratingsSearch={this.props.ratingsSearch}
        clearSearch={this.props.clearSearch}
        showOwnClanPosition={this.props.showOwnClanPosition}
        showSeasonLeaders={this.props.showSeasonLeaders}
        navigateToClan={this.navigateToClan}
        showCalendarModal={this.props.showCalendarModal}
        hideCalendarModal={this.props.hideCalendarModal}
        togglePlayersCountInRating={this.props.togglePlayersCountInRating}
        hideLastRoundResults={this.props.hideLastRoundResults}
        showLastRoundResults={this.props.showLastRoundResults}
        setUseAttempts={this.props.setUseAttempts}
        init={this.props.init}
        navigateToRecommendations={this.navigateToRecommendations}
        showHistoryModal={this.props.showHistoryModal}
        loadHistory={this.props.loadHistory}
        hideHistoryModal={this.props.hideHistoryModal}
        refreshHistoryModal={this.props.refreshHistoryModal}
      />
    )
  }
}

const mapStateToProps = (state: State) => {
  const clanId = state.currentAccount.clanId

  return {
    clanId: clanId,
    settings: state.settings,
    currentAccount: state.currentAccount,
    clanInfo: state.clans.items[clanId],
    selectedTab: state.ReducerClanWars.selectedTab,
    prepageStageTabIndex: state.ReducerClanWars.prepageStageTabIndex,
    isAttemptHistoryModalVisible: state.ReducerClanWars.isAttemptHistoryModalVisible,
    isStatModalVisible: state.ReducerClanWars.isStatModalVisible,
    autoParticipation: state.ReducerClanWars.autoParticipation,
    selectedStatisticNation: state.ReducerClanWars.selectedStatisticNation,
    selectedStatisticType: state.ReducerClanWars.selectedStatisticType,
    selectedAttemptsUserId: state.ReducerClanWars.selectedAttemptsUserId,
    isOnline: state.ReducerClanWars.isOnline,
    commonInfo: state.ReducerClanWars.commonInfo,
    stages: state.ReducerClanWars.stages,
    warSettings: state.ReducerClanWars.warSettings,
    groupedBattles: state.ReducerClanWars.groupedBattles,
    selectedClanRatingLeague: state.ReducerClanWars.selectedClanRatingLeague,
    searchInputValue: state.ReducerClanWars.searchInputValue,
    clanRatingList: state.ReducerClanWars.clanRatingList,
    clanRatingSearchList: state.ReducerClanWars.clanRatingSearchList,
    clanRatingAutocomplete: state.ReducerClanWars.clanRatingAutocomplete,
    selectedClanId: state.ReducerClanWars.selectedClanId,
    root: state.urls.root,
    isReady: state.ReducerClanWars.isReady,
    isCalendarModalVisible: state.ReducerClanWars.isCalendarModalVisible,
    isHistoryModalVisible: state.ReducerClanWars.isHistoryModalVisible,
    allPlayersInRatingTable: state.ReducerClanWars.allPlayersInRatingTable,
    restriction: state.ReducerClanWars.restriction,
    nextWeekStartDate: state.ReducerClanWars.nextWeekStartDate,
    lastRoundResults: state.ReducerClanWars.lastRoundResults,
    lastRoundResultsReady: state.ReducerClanWars.lastRoundResultsReady,
    lastRoundResultsHidden: state.ReducerClanWars.lastRoundResultsHidden,
    useAttempts: state.ReducerClanWars.useAttempts,
    isFromPort: state.ReducerClanWars.isFromPort,
    hasErrors: state.ReducerClanWars.hasErrors,
    ships: state.ReducerClanWars.ships,
    roundsHistory: state.ReducerClanWars.roundsHistory,
    roundsHistoryCount: state.ReducerClanWars.roundsHistoryCount,
    roundsHistoryLimit: state.ReducerClanWars.roundsHistoryLimit,
    roundsHistoryOffset: state.ReducerClanWars.roundsHistoryOffset,
    isRoundsHistoryLoading: state.ReducerClanWars.isRoundsHistoryLoading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSelectedTab: (selectedTab: number) => {
      dispatch(setSelectedTab(selectedTab))
    },
    setPrepareStageTab: (prepageStageTabIndex: number) => {
      dispatch(setPrepareStageTab(prepageStageTabIndex))
    },
    init: isReload => {
      dispatch(init(isReload))
    },
    showStatModal: () => {
      dispatch(showStatModal())
    },
    hideStatModal: () => {
      dispatch(hideStatModal())
    },
    showAttemptsModal: (id: string) => {
      dispatch(showAttemptsModal(id))
    },
    hideAttemptsModal: () => {
      dispatch(hideAttemptsModal())
    },
    toggleAutoParticipation: () => {
      dispatch(toggleAutoParticipation())
    },
    setIsParticipant: (value: boolean) => {
      dispatch(setIsParticipant(value))
    },
    showNationShipTypeStatistic: (nation: string, type: string) => {
      dispatch(showNationShipTypeStatistic(nation, type))
    },
    selectRatingLeague: (league: number) => {
      dispatch(selectRatingLeague(league))
    },
    searchInputChange: (value: string) => {
      dispatch(searchInputChange(value))
    },
    getRatings: (clanId?: number, league?: number) => {
      dispatch(getRatings(clanId, league))
    },
    ratingsSearch: (query: string) => {
      dispatch(ratingsSearch(query))
    },
    clearSearch: () => {
      dispatch(clearSearch())
    },
    showOwnClanPosition: () => {
      dispatch(showOwnClanPosition())
    },
    showSeasonLeaders: () => {
      dispatch(showSeasonLeaders())
    },
    showCalendarModal: () => {
      dispatch(showCalendarModal())
    },
    hideCalendarModal: () => {
      dispatch(hideCalendarModal())
    },
    togglePlayersCountInRating: () => {
      dispatch(togglePlayersCountInRating())
    },
    hideLastRoundResults: () => {
      dispatch(hideLastRoundResults())
    },
    showLastRoundResults: () => {
      dispatch(showLastRoundResults())
    },
    setUseAttempts: (val: boolean) => {
      dispatch(setUseAttempts(val))
    },
    showHistoryModal: () => {
      dispatch(showHistoryModal())
    },
    loadHistory: (limit: number, offset: number) => {
      dispatch(loadHistory(limit, offset))
    },
    hideHistoryModal: () => {
      dispatch(hideHistoryModal())
    },
    refreshHistoryModal: () => {
      dispatch(refreshHistoryModal())
    }
  }
}

export default translate()(connect(mapStateToProps, mapDispatchToProps)(ContainerClanWars))